import accountRoutes from './account'
import infoRoutes from './info'
import questionRoutes from './questions'
import socialRoutes from './social'
import profileRoutes from './profile'
import localePtBrRoutes from './localePtBr'
import pageTitles from './titles'

/** Locale-prefixed routes must be registered before `/:username` so `/pt-br` is not a profile. */
export default [].concat(accountRoutes, infoRoutes, questionRoutes, socialRoutes, localePtBrRoutes, profileRoutes)
export { pageTitles as titles }
